import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'styled-components';
import Plausible from 'plausible-tracker';

const { trackPageview } = Plausible({
	domain:'ggbleidraad.nl',
	hashMode: true,
});

trackPageview({
	url: location.hostname,
});

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
